export enum DateRange {
    UNDEFINED = 0,
    TODAY = 1,
    YESTERDAY = 2,
    CURRENT_WEEK = 3,
    LAST_WEEK = 4,
    CURRENT_MONTH = 5,
    LAST_MONTH = 6
}

export interface IQueryParams {
    DateRange: DateRange;
    Start: Date;
    End: Date;
    GraphicId: string;
    GraphicType: string;
    ExtraParams?: IExtraParams[]
}


export enum ExtraParamsKeys
{
    OS_QUITADAS_APENAS = 1,
    INCLUIR_ITENS_GRATUITOS = 2
}

export interface IExtraParams { 
    Key: ExtraParamsKeys;
    Value: any;
    Label?: string; 
}